'use client';

import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { splitHeroStatValue } from '../lib/splitHeroStatValue';

interface HeroCounterValueProps {
  value: string;
  delay?: number;
}

export default function HeroCounterValue({ value, delay = 0 }: HeroCounterValueProps) {
  const valueRef = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    const node = valueRef.current;
    if (!node || typeof window === 'undefined') return;

    const parsed = splitHeroStatValue(value);
    if (!parsed.isNumeric) {
      node.textContent = value;
      return;
    }

    const state = { val: 0 };
    const tween = gsap.to(state, {
      val: parsed.number,
      duration: 1.6,
      delay,
      ease: 'power2.out',
      onUpdate: () => {
        const display = parsed.useComma
          ? Math.round(state.val).toLocaleString('en-IN')
          : state.val.toFixed(parsed.decimals);
        node.textContent = `${display}${parsed.suffix}`;
      },
      onComplete: () => {
        node.textContent = value;
      },
    });

    return () => {
      tween.kill();
    };
  }, [value, delay]);

  return <span ref={valueRef}>0</span>;
}
